import * as React from 'react';
import useWidget from '@Utils/core/useWidget';
import { WidgetId } from '@Utils/edge/constants';
import CloseBlackBox from '@Utils/shared/components/Icons-v3/CloseBlackBox';
import DropdownContext from '../DropdownContext';
import * as Styled from '../Dropdown.styled';

const OpenedSection: React.FC = () => {
  const widgetGeneratorDropdownV3 = useWidget(WidgetId.GeneratorDropdownV3);
  const widgetGeneratorDropdownActiveV3 = useWidget(WidgetId.GeneratorDropdownActiveV3);

  const context = React.useContext(DropdownContext);

  const handleClose = () => {
    context.setIsOpen(false);
  };

  return (
    <Styled.DropContainer isVisible={context.isOpen}>
      <Styled.DropHeader>
        <Styled.DropTitle>{widgetGeneratorDropdownV3.strings.title}</Styled.DropTitle>
        <Styled.ClosePopup onClick={handleClose}>
          <CloseBlackBox />
        </Styled.ClosePopup>
      </Styled.DropHeader>
      <Styled.DropList>
        {widgetGeneratorDropdownV3.repeaters.group.map((item, index) => (
          <Styled.DropItem
            key={`${item.options.compositeId}-${index}`}
            onClick={handleClose}
            isActive={item.options.value === widgetGeneratorDropdownActiveV3.options.activeValue}
            href={item.links.url}
          >
            {item.strings.title}
          </Styled.DropItem>
        ))}
      </Styled.DropList>
    </Styled.DropContainer>
  );
};

export default OpenedSection;
